<template>
  <div id="tab_vendor_partnerships" class="tab-pane fade in active">
    <div class="library__group h-center-align" v-if="loaders.vendors || vendors.length > 0">
      <template v-if="featuredVendors.length > 0">
        <div class="library__group-header">Featured Vendors</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in featuredVendors" v-bind:key="`featured-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
      </template>
      <template v-if="categoriesUsed">
        <div class="library__group-header">Audiology</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in audiologyVendors" v-bind:key="`audiology-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
        <div class="library__group-header">Allergy & Sinus</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in allergyVendors" v-bind:key="`allergy-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
        <div class="library__group-header">Practice Management & Software Solutions</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in practiceManagementVendors" v-bind:key="`pm-software-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
        <div class="library__group-header">Finance & Merchant Solutions</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in financeVendors" v-bind:key="`finance-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
        <div class="library__group-header">Other Vendors</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in otherVendors" v-bind:key="`other-vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
      </template>
      <template v-else>
        <div class="library__group-header">Vendor Partners</div>
        <div class="library__collection library__collection--vendors">
          <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
          <VendorCard v-for="(vendor, index) in otherVendors" v-bind:key="`vendor-${index}`" :vendor="vendor"></VendorCard>
        </div>
      </template>

    </div>
    <VendorModal modal-key="vendorModal"></VendorModal>
    <FeaturedVendorModal modal-key="featuredVendorModal"></FeaturedVendorModal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import VendorCard from './cards/VendorCard.vue';
  import VendorModal from './modals/VendorModal.vue';
  import FeaturedVendorCard from './cards/FeaturedVendorCard.vue';
  import FeaturedVendorModal from './modals/FeaturedVendorModal.vue';

  export default {
    name: 'VendorPartnerships',
    components: {
      MoonLoader,
      VendorCard,
      VendorModal,
      FeaturedVendorCard,
      FeaturedVendorModal,
    },
    computed: {
      ...mapGetters('vendorPartners', [
        'loaders',
        'vendors',
        'featuredVendors',
        'audiologyVendors',
        'allergyVendors',
        'financeVendors',
        'practiceManagementVendors',
        'otherVendors',
        'categoriesUsed',
      ]),
    },
  };
</script>

